export default "__VITE_ASSET__CYhhoOfw__"